import Divider from "@/components/ui/Divider";

import { twMerge } from "tailwind-merge";

import FilterByAnalysisArea from "../filterByGrid";
import Overview from "../overview";

export type ReportSummaryProps = {
  className?: string;
  isExpanded: boolean;
  chartRef: React.RefObject<HTMLDivElement>;
  dynamicChartRef: React.RefObject<(HTMLDivElement | null)[]>;
};

export const ReportSummary = ({
  className,
  isExpanded,
  chartRef,
  dynamicChartRef
}: ReportSummaryProps) => {
  return (
    <div
      className={twMerge(
        className,
        isExpanded ? "gap-10 2xl:flex-col" : "flex-col"
      )}
    >
      <div className={twMerge(isExpanded ? "w-1/2 2xl:w-full" : "")}>
        <Overview isExpanded={isExpanded} chartRef={chartRef} />
      </div>

      <div className={twMerge(isExpanded ? "w-1/2 2xl:w-full" : "")}>
        {!isExpanded && (
          <Divider className="bg-white-smoke border-none w-full min-h-[8px] my-4 [&>div]:border-0" />
        )}

        <FilterByAnalysisArea
          isExpanded={isExpanded}
          dynamicChartRef={dynamicChartRef}
        />
      </div>
    </div>
  );
};
